export const SSR_QUERY_BLOCKED_DIGEST = 'CONFLUENCE_SSR_QUERY_BLOCKED';
// SSR deliberately stopped waiting at the streaming deadline and aborted every Suspense boundary
// still pending. The client renders them; it is not a server failure.
export const SSR_INTENTIONAL_ABORT_DIGEST = 'CONFLUENCE_SSR_INTENTIONAL_ABORT';

export class SSRIntentionalAbortError extends Error {
	constructor() {
		super('SSR intentionally aborted pending Suspense boundaries so the client renders them');
		this.name = 'SSRIntentionalAbortError';
	}
}

export class SSRQueryBlockedError extends Error {
	readonly operationName: string;

	constructor(operationName: string) {
		super('Query requires client rendering');
		this.name = 'SSRQueryBlockedError';
		this.operationName = operationName;
	}
}
